var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcehncalAppraisalImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41071",
    "data-name": "Group 41071",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 482.682,
    height: 453.087,
    viewBox: "0 0 482.682 453.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-11, .cls-12, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #4eb2a2;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: 0.7;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-11, .cls-6 {\r\n        stroke: #012d35;\r\n      }\r\n\r\n      .cls-12, .cls-6 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: 0.2;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clip-path-4);\r\n      }\r\n\r\n      .cls-9 {\r\n        clip-path: url(#clip-path-5);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #012d35;\r\n      }\r\n\r\n      .cls-11, .cls-12 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-12 {\r\n        stroke: #4eb2a2;\r\n        stroke-width: 6px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7925",
    "data-name": "Rectangle 7925",
    className: "cls-1",
    width: 482.682,
    height: 453.087
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7917",
    "data-name": "Rectangle 7917",
    className: "cls-1",
    width: 148.672,
    height: 179.687,
    transform: "translate(302.895 0.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7918",
    "data-name": "Rectangle 7918",
    className: "cls-1",
    width: 148.812,
    height: 179.656,
    transform: "translate(25.483 2.931)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41070",
    "data-name": "Group 41070",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41069",
    "data-name": "Group 41069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41068",
    "data-name": "Group 41068",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41015",
    "data-name": "Path 41015",
    className: "cls-3",
    d: "M455.184,307.568c-20.65,41.64-57.28,84.81-101.84,93.11-67.33,12.54-82.62,68.539-197.48,47.88a216.006,216.006,0,0,1-48.9-14.67,184.953,184.953,0,0,1-22.36-11.7c-63.52-39-90-109.64-83.7-179.07,8.22-91.32,71.76-126.92,112.68-147.23s99.26-112.581,212.34-93.241A209.347,209.347,0,0,1,376.194,17.7c36.73,16.44,72.26,46.71,90,86.4q2,4.469,3.74,9.1c22.72,60.25,13.4,137.6-14.75,194.37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41061",
    "data-name": "Group 41061",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41060",
    "data-name": "Group 41060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41059",
    "data-name": "Group 41059",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41016",
    "data-name": "Path 41016",
    className: "cls-5",
    d: "M455.184,307.568c-20.65,41.64-57.28,84.81-101.84,93.11-67.33,12.54-82.62,68.539-197.48,47.88a216.006,216.006,0,0,1-48.9-14.67,184.953,184.953,0,0,1-22.36-11.7c-63.52-39-90-109.64-83.7-179.07,8.22-91.32,71.76-126.92,112.68-147.23s99.26-112.581,212.34-93.241A209.347,209.347,0,0,1,376.194,17.7c36.73,16.44,72.26,46.71,90,86.4q2,4.469,3.74,9.1c22.72,60.25,13.4,137.6-14.75,194.37"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    className: "cls-6",
    x2: 13.4,
    transform: "translate(459.594 435.367)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    className: "cls-6",
    x2: 448.43,
    transform: "translate(1.344 435.367)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41064",
    "data-name": "Group 41064",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41063",
    "data-name": "Group 41063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41062",
    "data-name": "Group 41062",
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41017",
    "data-name": "Path 41017",
    d: "M318.434,34.128c3,3.149,12,6.76,12,6.76s.57-6.671.55-7.09c-.21-4.94-3.53-14.36-8.86-15.82A6.55,6.55,0,0,0,314.2,22.77a6.635,6.635,0,0,0-.132.7c-.65,3.851,1.83,7.971,4.37,10.661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41018",
    "data-name": "Path 41018",
    d: "M407.994,74.607c.06.08,4.16-5.25,4.38-5.61,2.54-4.24,5-13.92,1.33-18.09a6.546,6.546,0,0,0-9.75.14c-2.67,2.85-2.87,7.66-2.24,11.3.74,4.27,6.28,12.25,6.28,12.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41019",
    "data-name": "Path 41019",
    d: "M448.474,53.587c-4.84-2.7-13.81,1.671-17.43,5-.31.291-4.68,5.4-4.58,5.44h.1c-1.42.68-2.93,1.43-4.57,2.27-3,1.59-6.42,3.42-10,5.65a116.382,116.382,0,0,0-11.14,7.75,84.859,84.859,0,0,0-11.06,10.431l-.12.139c.66-1.479,2.38-5.68,2.47-6,1.34-4.75,1.12-14.729-3.49-17.789a6.538,6.538,0,0,0-9.014,2.073,6.679,6.679,0,0,0-.346.626c-1.82,3.46-.75,8.15.82,11.49,1.76,3.771,8.64,9.621,9.19,10.09a114.345,114.345,0,0,0-9.24,12.4c-1.65,2.519-3.23,5.1-4.78,7.72a24.814,24.814,0,0,0,1-2.641c1.34-4.75,1.12-14.73-3.49-17.79a6.54,6.54,0,0,0-9.014,2.073,6.826,6.826,0,0,0-.346.627c-1.82,3.46-.75,8.15.82,11.5s7.35,8.49,8.89,9.82c-.58,1-1.18,2-1.76,3-2.79,4.851-5.55,9.7-8.4,14.381-1,1.649-2.05,3.229-3.1,4.829.47-1.16.86-2.13.9-2.29,1.34-4.759,1.12-14.74-3.49-17.8a6.552,6.552,0,0,0-9.36,2.71c-1.82,3.46-.75,8.15.82,11.491s6.79,8,8.62,9.59c-1.12,1.589-2.24,3.2-3.4,4.69-.81,1-1.52,2-2.4,3l-2.5,2.889c-1.66,1.78-3.37,3.62-5,5.31-1.15,1.19-2.26,2.3-3.38,3.421,1-1.631,2.94-4.861,3.07-5.15a25.448,25.448,0,0,0,1.72-12.72,8.223,8.223,0,0,0,.48-1.371,6.548,6.548,0,0,0-4.488-8.1,6.354,6.354,0,0,0-.682-.157c-5.48-.78-12.28,6.519-14.45,11-.12.269-1.19,3.259-1.84,5.169.21-1.18.43-2.319.63-3.53.41-2.4.75-4.8,1.12-7.389.14-1.25.28-2.52.42-3.8s.18-2.62.28-3.94c.16-3.08.17-6.2.11-9.349,2.1.349,9.57,1.509,13.16.579s7.88-3.079,9.38-6.69a6.539,6.539,0,0,0-3.208-8.674,6.47,6.47,0,0,0-.672-.266c-5.33-1.65-13.16,4.59-15.93,8.59-.17.25-1.87,3.39-2.76,5.14-.05-1.9-.09-3.78-.2-5.7-.32-5.52-.82-11.09-1.29-16.659-.15-1.711-.27-3.411-.4-5.111.74.14,9.6,1.7,13.62.66,3.57-.92,7.87-3.08,9.38-6.69a6.561,6.561,0,0,0-3.88-8.94c-5.3-1.6-13.13,4.59-15.94,8.65-.22.31-2.65,4.831-3.21,6-.28-3.75-.53-7.49-.63-11.18a115.043,115.043,0,0,1,.5-15c.34.06,9.57,1.731,13.69.671,3.58-.921,7.88-3.081,9.38-6.69a6.542,6.542,0,0,0-3.208-8.676,6.458,6.458,0,0,0-.672-.264c-5.29-1.611-13.12,4.59-15.94,8.649-.18.27-2,3.71-2.88,5.37l-.3-.09a83.678,83.678,0,0,1,3.2-14.7c.79-2.65,1.7-5.139,2.64-7.539,1.68.489,9.42,2.629,13.23,2.079s8.17-2.2,10.06-5.609a6.551,6.551,0,0,0-2.87-9.32c-5.09-2.18-13.55,3.119-16.8,6.85-.17.2-1.74,2.459-2.86,4.12.44-1.081.88-2.2,1.32-3.22,1.64-3.851,3.39-7.271,5-10.291.91-1.709,1.76-3.23,2.57-4.65,1.91-.39,9.57-2,12.65-4.24s6.23-5.71,6.33-9.62A6.541,6.541,0,0,0,353.4.952a6.917,6.917,0,0,0-.72,0c-5.52.41-10.59,9-11.75,13.81-.1.42-.93,7.091-.82,7.07h.11c-.81,1.35-1.66,2.81-2.56,4.42-1.64,3-3.47,6.381-5.21,10.21a118.712,118.712,0,0,0-5,12.611,86.414,86.414,0,0,0-3.66,14.819,1.093,1.093,0,0,1,0,.181c-.27-1.6-1.16-6-1.26-6.38-1.51-4.71-7.2-12.921-12.73-12.921a6.539,6.539,0,0,0-6.32,7.421c.39,3.889,3.87,7.209,7,9.13,3.56,2.169,12.52,3.259,13.23,3.34a115.116,115.116,0,0,0-.86,15.449c0,3,.12,6,.27,9.07-.28-1.38-.53-2.609-.58-2.769-1.51-4.711-7.2-12.911-12.73-12.921a6.54,6.54,0,0,0-6.32,7.4c.39,3.89,3.87,7.211,7,9.13s10.82,3,12.84,3.29c.07,1.16.13,2.33.2,3.49.35,5.581.72,11.15.92,16.63.08,1.93.07,3.83.08,5.731-.24-1.22-.46-2.24-.51-2.4-1.51-4.7-7.19-12.909-12.73-12.92a6.539,6.539,0,0,0-6.31,7.43c.38,3.891,3.87,7.211,7,9.13s10.08,2.921,12.48,3.24c-.06,1.95-.11,3.9-.24,5.79-.13,1.28-.16,2.53-.35,3.82s-.34,2.53-.5,3.791c-.41,2.389-.81,4.87-1.26,7.2-.31,1.62-.63,3.16-.94,4.72-.05-1.93-.23-5.68-.28-6-.78-4.88-5.15-13.85-10.62-14.69a6.549,6.549,0,0,0-7.319,5.677,6.373,6.373,0,0,0-.051.7c-.2,3.9,2.73,7.71,5.56,10.09,3.11,2.611,11.45,5,12.49,5.28-.53,2.57-1.07,5.06-1.62,7.4-1.87,8.049-3.73,14.7-5.11,19.349l3.45,1.47.09-.31c1.29-4.75,3-11.549,4.77-19.8.55-2.6,1.09-5.4,1.62-8.271a72.507,72.507,0,0,0,8.35-.31c1.41,3.931,6.68,10.081,7.36,10.871-1.86,1.839-3.69,3.62-5.44,5.279-6,5.681-11.22,10.19-14.93,13.32l3.78,1.611c3.56-3.161,8.2-7.4,13.43-12.581,1.9-1.87,3.89-3.9,5.91-6,.88.611,8,5.54,12,6.271,3.63.669,8.44.5,11.32-2.141a6.551,6.551,0,0,0,.712-9.236,7.014,7.014,0,0,0-.492-.514c-4.13-3.67-13.84-1.329-18.1,1.18-.25.14-2.79,2-4.38,3.29.82-.87,1.63-1.7,2.47-2.6,1.66-1.77,3.27-3.59,5-5.54l2.44-2.939c.84-1,1.6-2.09,2.41-3.141,1.83-2.48,3.57-5.079,5.26-7.73,1.55,1.45,7.15,6.54,10.65,7.75s8.27,1.77,11.52-.409a6.55,6.55,0,0,0,2.094-9.024,6.257,6.257,0,0,0-.4-.576c-3.53-4.261-13.47-3.411-18.06-1.581-.29.11-3.44,1.8-5.14,2.76,1-1.6,2-3.2,3-4.86,2.78-4.779,5.44-9.71,8.12-14.61q1.23-2.25,2.48-4.479c.55.52,7.07,6.71,11,8.069,3.48,1.2,8.26,1.77,11.51-.41a6.543,6.543,0,0,0,1.7-9.6c-3.54-4.261-13.48-3.41-18.07-1.581-.35.141-4.87,2.57-6,3.25,1.83-3.29,3.68-6.54,5.64-9.68a116.318,116.318,0,0,1,8.67-12.2c.25.25,7,6.74,11.05,8.13,3.49,1.2,8.27,1.771,11.51-.41a6.55,6.55,0,0,0,2.105-9.021,6.753,6.753,0,0,0-.4-.579c-3.53-4.259-13.48-3.409-18.07-1.58-.3.12-3.75,2-5.37,2.89l-.2-.25a84.939,84.939,0,0,1,10.78-10.49c2.13-1.769,4.26-3.35,6.36-4.829,1.14,1.329,6.41,7.389,9.89,9s8,2.669,11.49.859a6.55,6.55,0,0,0,3.075-8.738,6.707,6.707,0,0,0-.335-.612c-3-4.629-13-4.879-17.78-3.56-.26.07-2.82,1.1-4.66,1.861,1-.65,1.94-1.351,2.87-2,3.5-2.3,6.84-4.191,9.81-5.84,1.7-.921,3.26-1.731,4.72-2.461,1.8.73,9.1,3.58,12.88,3.44s8.35-1.33,10.59-4.53a6.541,6.541,0,0,0-1.345-9.151c-.147-.108-.3-.212-.455-.309"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41067",
    "data-name": "Group 41067",
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41066",
    "data-name": "Group 41066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41065",
    "data-name": "Group 41065",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41020",
    "data-name": "Path 41020",
    d: "M158.724,36.057c-3,3.16-12,6.761-12,6.77s-.57-6.669-.55-7.1c.21-4.94,3.53-14.35,8.87-15.82a6.548,6.548,0,0,1,7.883,4.863c.049.207.088.415.117.626.69,3.85-1.79,7.981-4.32,10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41021",
    "data-name": "Path 41021",
    d: "M69.154,76.538c0,.09-4.15-5.24-4.37-5.61-2.55-4.24-4.99-13.92-1.33-18.04a6.557,6.557,0,0,1,9.74.139c2.67,2.861,2.88,7.661,2.25,11.3-.74,4.22-6.28,12.21-6.29,12.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41022",
    "data-name": "Path 41022",
    d: "M28.684,55.518c4.83-2.7,13.8,1.67,17.42,5,.31.29,4.68,5.4,4.59,5.44h-.11c1.42.67,2.94,1.42,4.58,2.27,3,1.59,6.41,3.41,10,5.64a119.409,119.409,0,0,1,11.15,7.75,86.837,86.837,0,0,1,11.08,10.44l.11.15c-.66-1.48-2.37-5.69-2.47-6-1.33-4.76-1.12-14.74,3.49-17.8a6.549,6.549,0,0,1,9.025,2.085,6.342,6.342,0,0,1,.345.625c1.82,3.45.75,8.15-.82,11.49-1.77,3.77-8.65,9.62-9.2,10.08a116.065,116.065,0,0,1,9.25,12.41c1.64,2.51,3.22,5.1,4.78,7.71a22.778,22.778,0,0,1-1-2.63c-1.33-4.76-1.12-14.74,3.49-17.8a6.549,6.549,0,0,1,9.025,2.085,6.342,6.342,0,0,1,.345.625c1.82,3.46.75,8.15-.82,11.49s-7.36,8.5-8.9,9.83c.59,1,1.18,2,1.76,3,2.79,4.85,5.55,9.7,8.4,14.37,1,1.65,2.06,3.24,3.1,4.83-.47-1.15-.85-2.13-.9-2.28-1.33-4.76-1.12-14.74,3.49-17.8a6.549,6.549,0,0,1,9.025,2.085,6.345,6.345,0,0,1,.345.625c1.82,3.45.75,8.15-.82,11.49s-6.8,8-8.62,9.58c1.12,1.6,2.24,3.2,3.39,4.7.82,1,1.53,2,2.4,3l2.51,2.88c1.66,1.78,3.36,3.62,5,5.32,1.15,1.18,2.27,2.29,3.39,3.41-1-1.63-2.95-4.86-3.08-5.151a25.313,25.313,0,0,1-1.71-12.719,8.2,8.2,0,0,1-.49-1.36,6.55,6.55,0,0,1,4.505-8.094,6.652,6.652,0,0,1,.685-.156c5.48-.79,12.28,6.52,14.45,11,.13.26,1.2,3.26,1.84,5.16-.21-1.18-.42-2.31-.62-3.53-.41-2.39-.75-4.8-1.13-7.38-.13-1.26-.27-2.52-.41-3.8s-.18-2.63-.28-4c-.16-3.08-.17-6.2-.12-9.35-2.1.36-9.57,1.51-13.16.59s-7.87-3.09-9.38-6.69a6.559,6.559,0,0,1,3.235-8.695,6.75,6.75,0,0,1,.645-.255c5.3-1.6,13.13,4.59,15.94,8.65.18.26,1.87,3.4,2.77,5.14.05-1.89.08-3.78.2-5.69.32-5.52.81-11.1,1.29-16.67.14-1.7.26-3.4.4-5.11-.75.14-9.6,1.7-13.62.67-3.58-.92-7.88-3.09-9.38-6.69a6.54,6.54,0,0,1,3.208-8.675,6.7,6.7,0,0,1,.672-.265c5.29-1.61,13.12,4.58,15.94,8.64.21.31,2.64,4.83,3.2,6,.29-3.74.54-7.48.64-11.18a115.153,115.153,0,0,0-.5-14.95c-.35.06-9.58,1.74-13.7.68-3.57-.92-7.87-3.09-9.38-6.69a6.561,6.561,0,0,1,3.88-9c5.3-1.6,13.13,4.59,15.94,8.65.19.27,2,3.72,2.89,5.37l.3-.09a84.726,84.726,0,0,0-3.21-14.7c-.79-2.65-1.7-5.14-2.63-7.54-1.69.49-9.43,2.63-13.24,2.09-3.65-.52-8.16-2.2-10.06-5.62a6.55,6.55,0,0,1,2.26-8.983,6.663,6.663,0,0,1,.62-.327c5.09-2.18,13.55,3.11,16.79,6.84.18.2,1.74,2.46,2.86,4.12-.44-1.07-.87-2.19-1.31-3.22-1.65-3.84-3.4-7.27-5-10.28-.9-1.71-1.76-3.24-2.57-4.66-1.91-.39-9.57-2-12.64-4.23s-6.26-5.66-6.34-9.58a6.565,6.565,0,0,1,6.84-6.95c5.52.41,10.59,9,11.75,13.82.1.41.93,7.09.83,7.07h-.12c.81,1.35,1.67,2.81,2.57,4.42,1.64,3,3.46,6.39,5.2,10.21a114.116,114.116,0,0,1,5,12.62,84.769,84.769,0,0,1,3.56,14.76v.18c.26-1.6,1.15-6.05,1.26-6.38,1.55-4.75,7.19-12.92,12.77-12.93a6.56,6.56,0,0,1,6.376,6.739,6.656,6.656,0,0,1-.056.691c-.39,3.88-3.88,7.21-7,9.13-3.55,2.16-12.51,3.25-13.23,3.33a115.127,115.127,0,0,1,.87,15.45c0,3-.13,6-.27,9.07.27-1.37.53-2.6.58-2.77,1.51-4.71,7.19-12.91,12.73-12.92a6.56,6.56,0,0,1,6.376,6.739,6.656,6.656,0,0,1-.056.691c-.39,3.88-3.88,7.21-7,9.13s-10.82,3-12.84,3.29c-.07,1.16-.12,2.32-.2,3.49-.35,5.58-.72,11.15-.92,16.62-.07,1.93-.07,3.83-.08,5.74.25-1.22.46-2.25.51-2.4,1.51-4.71,7.2-12.92,12.73-12.92a6.54,6.54,0,0,1,6.378,6.7,6.447,6.447,0,0,1-.058.722c-.39,3.89-3.87,7.21-7,9.13s-10.08,2.92-12.48,3.24c0,1.95.1,3.9.24,5.79.12,1.29.15,2.53.35,3.82s.33,2.54.5,3.79c.4,2.4.8,4.87,1.26,7.2.3,1.63.62,3.17.94,4.72,0-1.92.22-5.68.27-6,.78-4.88,5.16-13.85,10.63-14.7a6.542,6.542,0,0,1,7.36,6.381c.21,3.9-2.73,7.71-5.55,10.09-3.11,2.62-11.46,5-12.5,5.279.53,2.571,1.08,5.061,1.63,7.4,1.87,8.06,3.73,14.7,5.11,19.36l-3.46,1.47a.481.481,0,0,0-.08-.32c-1.29-4.74-3.05-11.55-4.78-19.8-.55-2.6-1.09-5.4-1.61-8.27a70.283,70.283,0,0,1-8.36-.31c-1.4,3.93-6.67,10.08-7.36,10.87,1.86,1.849,3.69,3.63,5.44,5.28,6,5.68,11.22,10.2,14.94,13.319l-3.91,1.621c-3.55-3.15-8.19-7.4-13.43-12.57-1.89-1.87-3.89-3.91-5.91-6-.87.6-8,5.54-12,6.27-3.64.66-8.45.49-11.32-2.15a6.54,6.54,0,0,1-.726-9.22,6.414,6.414,0,0,1,.5-.52c4.14-3.681,13.84-1.34,18.1,1.17.25.149,2.8,2.06,4.38,3.29-.82-.87-1.63-1.7-2.46-2.6-1.67-1.77-3.28-3.59-5-5.541l-2.44-2.939c-.84-1-1.6-2.09-2.41-3.14-1.83-2.47-3.56-5.07-5.25-7.73-1.56,1.46-7.15,6.54-10.66,7.75s-8.27,1.77-11.51-.41a6.54,6.54,0,0,1-2.109-9.005,6.442,6.442,0,0,1,.409-.585c3.53-4.27,13.48-3.42,18.07-1.59.28.12,3.43,1.81,5.14,2.77-1-1.61-2-3.21-3-4.86-2.77-4.78-5.44-9.71-8.11-14.61-.82-1.51-1.66-3-2.49-4.49-.54.53-7.07,6.71-11,8.07-3.49,1.21-8.27,1.769-11.52-.4a6.549,6.549,0,0,1-2.094-9.023,6.414,6.414,0,0,1,.4-.577c3.53-4.27,13.48-3.42,18.06-1.58.35.13,4.87,2.57,6,3.24-1.83-3.28-3.68-6.54-5.64-9.67a112.964,112.964,0,0,0-8.66-12.2c-.26.24-7,6.73-11,8.12-3.49,1.2-8.27,1.77-11.52-.41a6.54,6.54,0,0,1-2.116-9,6.638,6.638,0,0,1,.386-.556c3.53-4.27,13.47-3.42,18.06-1.59.3.12,3.75,2,5.37,2.89l.2-.24a84.353,84.353,0,0,0-10.78-10.5c-2.12-1.77-4.25-3.34-6.36-4.83-1.14,1.34-6.41,7.39-9.89,9-3.33,1.59-8,2.67-11.48.87a6.55,6.55,0,0,1-3.093-8.731,6.482,6.482,0,0,1,.343-.629c3.05-4.62,13-4.87,17.79-3.55.26.07,2.81,1.09,4.66,1.86-1-.66-1.94-1.35-2.87-2-3.5-2.3-6.84-4.19-9.82-5.85-1.7-.88-3.2-1.7-4.72-2.42-1.8.73-9.1,3.58-12.88,3.45s-8.35-1.33-10.6-4.53A6.56,6.56,0,0,1,28.108,55.9a6.354,6.354,0,0,1,.576-.386"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_41023",
    "data-name": "Path 41023",
    className: "cls-6",
    d: "M463.4,149.517v4.56a2.13,2.13,0,0,1-4.25,0v-4.56h-12.43v4.56a2.13,2.13,0,0,1-4.25,0v-4.56h-12.42v4.56a2.13,2.13,0,1,1-4.26,0v-4.56h-12.42v4.56a2.13,2.13,0,0,1-4.25,0v-4.56h-12.43v4.56a2.12,2.12,0,1,1-4.24,0v-4.56h-5.66v59h82.37v-59Zm-63.06,50.49h-6.41V193.6h6.41Zm0-9.3h-6.41V184.3h6.41Zm0-9.3h-6.41V175h6.41Zm0-9.3h-6.41V165.7h6.41Zm10.27,27.9h-6.42V193.6h6.42Zm0-9.3h-6.42V184.3h6.42Zm0-9.3h-6.42V175h6.42Zm0-9.3h-6.42V165.7h6.42Zm10.25,27.9h-6.4V193.6h6.4Zm0-9.3h-6.4V184.3h6.4Zm0-9.3h-6.4V175h6.4Zm0-9.3h-6.4V165.7h6.4Zm10.27,27.9h-6.42V193.6h6.42Zm0-9.3h-6.42V184.3h6.42Zm0-9.3h-6.42V175h6.42Zm0-9.3h-6.42V165.7h6.42Zm10.26,27.9h-6.41V193.6h6.41Zm0-9.3h-6.41V184.3h6.41Zm0-9.3h-6.41V175h6.41Zm0-9.3h-6.41V165.7h6.41Zm10.27,27.9h-6.42V193.6h6.42Zm0-9.3h-6.42V184.3h6.42Zm0-9.3h-6.42V175h6.42Zm0-9.3h-6.42V165.7h6.42Zm10.25,27.9h-6.4V193.6h6.4Zm0-9.3h-6.4V184.3h6.4Zm0-9.3h-6.4V175h6.4Zm0-9.3h-6.4V165.7h6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41024",
    "data-name": "Path 41024",
    className: "cls-6",
    d: "M463.4,144.727v9.35a2.13,2.13,0,0,1-4.25,0v-9.35a2.13,2.13,0,0,1,4.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41025",
    "data-name": "Path 41025",
    className: "cls-6",
    d: "M446.724,144.727v9.35a2.13,2.13,0,0,1-4.25,0v-9.35a2.13,2.13,0,0,1,4.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41026",
    "data-name": "Path 41026",
    className: "cls-6",
    d: "M430.054,144.727v9.35a2.13,2.13,0,1,1-4.26,0v-9.35a2.12,2.12,0,0,1,2.12-2.12h.01a2.071,2.071,0,0,1,1.5.62A2.1,2.1,0,0,1,430.054,144.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41027",
    "data-name": "Path 41027",
    className: "cls-6",
    d: "M413.374,144.727v9.35a2.13,2.13,0,0,1-4.25,0v-9.35a2.12,2.12,0,0,1,2.12-2.12h.01A2.12,2.12,0,0,1,413.374,144.727Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41028",
    "data-name": "Path 41028",
    className: "cls-6",
    d: "M396.694,144.727v9.35a2.12,2.12,0,1,1-4.24,0v-9.35a2.12,2.12,0,1,1,4.24,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1277",
    "data-name": "Ellipse 1277",
    className: "cls-6",
    cx: 33.85,
    cy: 33.85,
    r: 33.85,
    transform: "translate(26.264 145.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41029",
    "data-name": "Path 41029",
    className: "cls-6",
    d: "M53.325,150.319a29.94,29.94,0,1,1-22.35,35.962A29.94,29.94,0,0,1,53.325,150.319Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41030",
    "data-name": "Path 41030",
    className: "cls-10",
    d: "M60.114,176.617a2.86,2.86,0,1,1-2.86,2.86,2.859,2.859,0,0,1,2.86-2.86"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1278",
    "data-name": "Ellipse 1278",
    className: "cls-6",
    cx: 2.86,
    cy: 2.86,
    r: 2.86,
    transform: "translate(57.254 176.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41031",
    "data-name": "Path 41031",
    className: "cls-6",
    d: "M70.534,184.577l-10.42-5.1-17.37,18.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41032",
    "data-name": "Path 41032",
    className: "cls-10",
    d: "M123.224,51.738h241.43a6.08,6.08,0,0,1,6.08,6.08v363.33a6.08,6.08,0,0,1-6.08,6.08H123.224a6.08,6.08,0,0,1-6.08-6.08V57.818a6.08,6.08,0,0,1,6.08-6.08"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7919",
    "data-name": "Rectangle 7919",
    className: "cls-6",
    width: 253.59,
    height: 375.49,
    rx: 6.08,
    transform: "translate(117.144 51.738)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7920",
    "data-name": "Rectangle 7920",
    className: "cls-5",
    width: 227.82,
    height: 352.55,
    transform: "translate(130.034 60.207)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7921",
    "data-name": "Rectangle 7921",
    className: "cls-6",
    width: 227.82,
    height: 352.55,
    transform: "translate(130.034 60.207)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    className: "cls-11",
    x2: 17.69,
    transform: "translate(275.754 151.667)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    className: "cls-11",
    x2: 108.99,
    transform: "translate(153.064 151.667)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_222",
    "data-name": "Line 222",
    className: "cls-11",
    x2: 43.94,
    transform: "translate(249.504 165.367)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    className: "cls-11",
    x2: 55.36,
    transform: "translate(182.164 165.367)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    className: "cls-11",
    x2: 18.83,
    transform: "translate(153.064 165.367)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    className: "cls-11",
    x2: 85.6,
    transform: "translate(207.844 179.057)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    className: "cls-11",
    x2: 35.95,
    transform: "translate(153.064 179.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41033",
    "data-name": "Path 41033",
    className: "cls-11",
    d: "M325.534,149.785a14.84,14.84,0,1,1-11.006,17.869A14.839,14.839,0,0,1,325.534,149.785Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_227",
    "data-name": "Line 227",
    className: "cls-11",
    x1: 17.69,
    transform: "translate(153.064 212.728)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    className: "cls-11",
    x1: 108.99,
    transform: "translate(184.454 212.728)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    className: "cls-11",
    x1: 43.94,
    transform: "translate(153.064 226.428)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    className: "cls-11",
    x1: 55.36,
    transform: "translate(208.984 226.428)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    className: "cls-11",
    x1: 18.83,
    transform: "translate(274.614 226.428)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    className: "cls-11",
    x1: 85.6,
    transform: "translate(153.064 240.118)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    className: "cls-11",
    x1: 35.95,
    transform: "translate(257.494 240.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41034",
    "data-name": "Path 41034",
    className: "cls-11",
    d: "M325.531,210.83A14.84,14.84,0,1,1,314.525,228.7,14.839,14.839,0,0,1,325.531,210.83Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    className: "cls-11",
    x2: 17.69,
    transform: "translate(275.754 273.788)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_235",
    "data-name": "Line 235",
    className: "cls-11",
    x2: 108.99,
    transform: "translate(153.064 273.788)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_236",
    "data-name": "Line 236",
    className: "cls-11",
    x2: 43.94,
    transform: "translate(249.504 287.487)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_237",
    "data-name": "Line 237",
    className: "cls-11",
    x2: 55.36,
    transform: "translate(182.164 287.487)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_238",
    "data-name": "Line 238",
    className: "cls-11",
    x2: 18.83,
    transform: "translate(153.064 287.487)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    className: "cls-11",
    x2: 85.6,
    transform: "translate(207.844 301.177)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    className: "cls-11",
    x2: 35.95,
    transform: "translate(153.064 301.177)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1279",
    "data-name": "Ellipse 1279",
    className: "cls-11",
    cx: 14.84,
    cy: 14.84,
    r: 14.84,
    transform: "translate(314.118 271.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41035",
    "data-name": "Path 41035",
    className: "cls-10",
    d: "M263.124,22.167a1.941,1.941,0,0,1-1.94-1.94V9.327a4.121,4.121,0,0,0-4.12-4.12h-17.57a4.121,4.121,0,0,0-4.13,4.11v10.91a1.93,1.93,0,0,1-1.92,1.94h-.01a1.93,1.93,0,0,0-1.94,1.92v29.54h33.56V24.1A1.93,1.93,0,0,0,263.124,22.167Zm-14.85-1a5.4,5.4,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41036",
    "data-name": "Path 41036",
    className: "cls-6",
    d: "M263.124,22.167a1.941,1.941,0,0,1-1.94-1.94V9.327a4.121,4.121,0,0,0-4.12-4.12h-17.57a4.121,4.121,0,0,0-4.13,4.11v10.91a1.93,1.93,0,0,1-1.92,1.94h-.01a1.93,1.93,0,0,0-1.94,1.92v29.54h33.56V24.1A1.93,1.93,0,0,0,263.124,22.167Zm-14.85-1a5.4,5.4,0,1,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41037",
    "data-name": "Path 41037",
    className: "cls-5",
    d: "M204.524,44.238h87.51a8.651,8.651,0,0,1,8.64,8.65v9.95h-104.8v-9.95a8.65,8.65,0,0,1,8.65-8.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41038",
    "data-name": "Path 41038",
    className: "cls-6",
    d: "M204.524,44.238h87.51a8.651,8.651,0,0,1,8.64,8.65v9.95h-104.8v-9.95A8.65,8.65,0,0,1,204.524,44.238Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41039",
    "data-name": "Path 41039",
    className: "cls-10",
    d: "M198.474,47.458h99.61a9.853,9.853,0,0,0-7.29-3.22h-85a9.828,9.828,0,0,0-7.32,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41040",
    "data-name": "Path 41040",
    className: "cls-6",
    d: "M198.474,47.458h99.61a9.853,9.853,0,0,0-7.29-3.22h-85A9.828,9.828,0,0,0,198.474,47.458Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7922",
    "data-name": "Rectangle 7922",
    className: "cls-5",
    width: 104.8,
    height: 6.11,
    transform: "translate(195.874 62.747)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7923",
    "data-name": "Rectangle 7923",
    className: "cls-6",
    width: 104.8,
    height: 6.11,
    transform: "translate(195.874 62.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41041",
    "data-name": "Path 41041",
    className: "cls-12",
    d: "M323.3,222.827l4.03,7.16,15.24-14.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41042",
    "data-name": "Path 41042",
    className: "cls-12",
    d: "M323.3,161.117l4.03,7.17,15.24-14.79"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    className: "cls-11",
    x2: 17.69,
    transform: "translate(275.754 91.307)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    className: "cls-11",
    x2: 108.99,
    transform: "translate(153.064 91.307)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    className: "cls-11",
    x2: 43.94,
    transform: "translate(249.504 104.997)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    className: "cls-11",
    x2: 55.36,
    transform: "translate(182.164 104.997)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    className: "cls-11",
    x2: 18.83,
    transform: "translate(153.064 104.997)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    className: "cls-11",
    x2: 85.6,
    transform: "translate(207.844 118.697)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    className: "cls-11",
    x2: 35.95,
    transform: "translate(153.064 118.697)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1280",
    "data-name": "Ellipse 1280",
    className: "cls-11",
    cx: 14.84,
    cy: 14.84,
    r: 14.84,
    transform: "translate(314.125 89.011)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41043",
    "data-name": "Path 41043",
    className: "cls-12",
    d: "M323.3,100.758l4.03,7.17,15.24-14.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41044",
    "data-name": "Path 41044",
    className: "cls-12",
    d: "M321.174,281.047l4.03,7.17,15.23-14.79"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    className: "cls-11",
    x2: 17.69,
    transform: "translate(275.754 335.696)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    className: "cls-11",
    x2: 108.99,
    transform: "translate(153.064 335.696)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    className: "cls-11",
    x2: 43.94,
    transform: "translate(249.504 349.396)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    className: "cls-11",
    x2: 55.36,
    transform: "translate(182.164 349.396)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    className: "cls-11",
    x2: 18.83,
    transform: "translate(153.064 349.396)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    className: "cls-11",
    x2: 85.6,
    transform: "translate(207.844 363.086)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    className: "cls-11",
    x2: 35.95,
    transform: "translate(153.064 363.086)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1281",
    "data-name": "Ellipse 1281",
    className: "cls-11",
    cx: 14.84,
    cy: 14.84,
    r: 14.84,
    transform: "translate(314.118 333.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41045",
    "data-name": "Path 41045",
    className: "cls-12",
    d: "M321.174,342.956l4.03,7.17,15.23-14.79"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcehncalAppraisalImg);
export default __webpack_public_path__ + "static/media/tcehncal_appraisal_Img.4d88373b199b1d87c339719474601531.svg";
export { ForwardRef as ReactComponent };